<template>
  <pt-batch-add-lab-order class="pt-batch-add-lab-order__page"></pt-batch-add-lab-order>
</template>

<script>
import PtBatchAddLabOrder from 'cps//pt-batch-add-lab-order/withData'
export default {
  name: 'pt-batch-add-lab-order__view',
  components: {
    'pt-batch-add-lab-order': PtBatchAddLabOrder
  }
}
</script>
